<template>
  <!-- eslint-disable vue/no-v-html -->
  <div class="config-teams f-h">
    <!-- Group actions when selecting users -->
    <LeftDrawerPanel
      right
      no-expander
      :displayed="selectedItems.length > 0"
    >
      <h1 class="basic-blue-title" style="text-align: left; background: transparent; padding-top: 0px;">
        {{ $t('message.ACTIONS') }}
      </h1>
      <!-- Panel content: Teams actions -->
      <div v-if="viewMode === 0">
        <button
          v-if="selectedItems.length === 1"
          class="add-button clickable-hoverable"
          @click="editItem(selectedItems[0])"
        >
          <Icon>{{ Icons.editMedium }}</Icon>
          <span>{{ $t('message.EDIT') }}</span>
        </button>
        <div v-if="selectedItems.length === 1" class="sep" />
        <button class="add-button clickable-hoverable" @click="assigningTemplates = true">
          <Icon>{{ Icons.pageMedium }}</Icon>
          <span>{{ $t('message.CONFIG_STARTUP_TEMPLATE') }}</span>
        </button>
        <div class="sep" />
        <button class="add-button clickable-hoverable" @click="configIndicators()">
          <Icon>{{ Icons.barChartMedium }}</Icon>
          <span>{{ $t('message.CONFIG_INDICATORS') }}</span>
        </button>
        <button class="add-button clickable-hoverable" @click="configWorkingDays()">
          <Icon>{{ Icons.planningMedium }}</Icon>
          <span>{{ $t('message.CONFIG_WORKING_DAYS') }}</span>
        </button>
        <button class="add-button clickable-hoverable" @click="$refs.actionPlansSelection.edit()">
          <Icon>{{ Icons.checklistMedium }}</Icon>
          <span>{{ $t('message.CONFIG_ACTION_PLANS') }}</span>
        </button>
        <button class="add-button clickable-hoverable" @click="assigningMeetings = true">
          <Icon>{{ Icons.meetingMedium }}</Icon>
          <span>{{ $t('message.CONFIG_ASSIGN_MEETINGS') }}</span>
        </button>
        <button class="add-button clickable-hoverable" @click="assigningCfgPages = true">
          <Icon>{{ Icons.cfgPageMedium }}</Icon>
          <span>{{ $t('message.CONFIG_ASSIGN_CFG_PAGES') }}</span>
        </button>
        <button
          v-if="selectedItems.length === 1 && selectedItems[0].id === 101546"
          class="add-button clickable-hoverable"
          @click="resetDiwiiAccount"
        >
          <Icon>{{ Icons.cancelMedium }}</Icon>
          <span>{{ $t('message.RESET') }}</span>
        </button>
        <button
          class="add-button clickable-hoverable"
          :class="{ 'greyed-out': !selectedItems.some(t => !t.locked) }"
          @click="lockTeams(selectedItems.map(t => t.id), true)"
        >
          <Icon>{{ Icons.lockMedium }}</Icon>
          <span>{{ $t('message.CONFIG_DISABLE_ACCOUNT') }}</span>
        </button>
        <button
          class="add-button clickable-hoverable"
          :class="{ 'greyed-out': !selectedItems.some(t => t.locked) }"
          @click="lockTeams(selectedItems.map(t => t.id), false)"
        >
          <Icon>{{ Icons.unlockMedium }}</Icon>
          <span>{{ $t('message.CONFIG_ENABLE_ACCOUNT') }}</span>
        </button>
        <button class="add-button clickable-hoverable red" @click="deleteItem(selectedItems.map(u => u.id))">
          <Icon>{{ Icons.deleteMedium }}</Icon>
          <span>{{ $t('message.DELETE_SELECTION') }}</span>
        </button>
        <EditableLabelRadio
          ref="wdEdit"
          v-model="workingDaysEdition.val"
          :multiple="true"
          :items="workingDaysEdition.data"
          label-key="title"
          :no-text="true"
          :ok-button="true"
          @ok="workingDaysEdited()"
        />
        <button class="add-button blue" @click="selectAll()">
          {{ $t('message.UNSELECT_ALL') }}
        </button>
      </div>
      <!-- Panel content: Users actions -->
      <div v-if="viewMode === 1">
        <button
          v-if="selectedItems.length === 1"
          class="add-button clickable-hoverable"
          @click="editItem(selectedItems[0])"
        >
          <Icon>{{ Icons.editMedium }}</Icon>
          <span>{{ $t('message.EDIT') }}</span>
        </button>
        <button class="add-button clickable-hoverable" @click="assignSelected()">
          <Icon>{{ Icons.teamMedium }}</Icon>
          <span>{{ $t('message.ASSIGN_SELECTION') }}</span>
        </button>
        <button class="add-button clickable-hoverable" @click="sendUsersCredentials(selectedItems.map(u => u.id))">
          <Icon>{{ Icons.sendCredentials }}</Icon>
          <span>{{ $t('message.CONFIG_SEND_USERS_NEW_CREDENTIALS') }}</span>
        </button>
        <button
          class="add-button clickable-hoverable"
          :class="{ 'greyed-out': !selectedItems.some(u => !u.locked) }"
          @click="lockUsers(selectedItems.map(u => u.id), true)"
        >
          <Icon>{{ Icons.lockMedium }}</Icon>
          <span>{{ $t('message.CONFIG_DISABLE_ACCOUNT') }}</span>
        </button>
        <button
          class="add-button clickable-hoverable"
          :class="{ 'greyed-out': !selectedItems.some(u => u.locked) }"
          @click="lockUsers(selectedItems.map(u => u.id), false)"
        >
          <Icon>{{ Icons.unlockMedium }}</Icon>
          <span>{{ $t('message.CONFIG_ENABLE_ACCOUNT') }}</span>
        </button>
        <button class="add-button clickable-hoverable red" @click="deleteItem(selectedItems.map(u => u.id))">
          <Icon>{{ Icons.deleteMedium }}</Icon>
          <span>{{ $t('message.DELETE_SELECTION') }}</span>
        </button>
        <!-- Only one user selected and he asked for his data to be removed -->
        <div v-if="selectedItems.length === 1 && selectedItems[0].eraseRequest" class="erase-data-actions">
          <div class="field-hint">
            {{ $t("This user asked for his data to be removed") }}
          </div>
          <button class="add-button clickable-hoverable" @click="promptEraseUserData(selectedItems[0])">
            <Icon>{{ Icons.lockMedium }}</Icon>
            <span>{{ $t('message.ERASE_USER_DATA') }}</span>
          </button>
          <button class="add-button clickable-hoverable" @click="cancelEraseUserData(selectedItems[0])">
            <Icon>{{ Icons.closeMedium }}</Icon>
            <span>{{ $t('message.CANCEL_USER_DATA_REMOVAL_REQUEST') }}</span>
          </button>
        </div>
        <button class="add-button blue" @click="selectAll()">
          <span>{{ $t('message.UNSELECT_ALL') }}</span>
        </button>
      </div>
    </LeftDrawerPanel>
    <div class="f-h">
      <!-- Filters options -->
      <div class="filters f-h">
        <div class="h-v-centerer">
          <Switcher
            v-model="viewMode"
            :titles="viewModeTitles"
            style="z-index: 10002;"
          />
        </div>
        <h2 class="basic-sub-title">
          {{ $t('message.SEARCH') }}
        </h2>
        <div class="filter-option generic-border--thin-border">
          <div class="basic-search-field v-centerer">
            <Icon>{{ Icons.searchMedium }}</Icon>
            <input v-model="search" :placeholder="$t('message.SEARCH_PH')">
          </div>
        </div>
        <h2 class="basic-sub-title">
          {{ $t('message.SORT') }}
        </h2>
        <div class="filter-option generic-border--thin-border">
          <RadioGroup v-model="sortBy" :items="sortItems" :sortable="true" />
        </div>
        <h2 class="basic-sub-title">
          {{ $t('message.FILTERS') }}
        </h2>
        <div class="filter-option generic-border--thin-border">
          <div class="legend">
            {{ $t('message.HIERARCHY_LEVEL') }}
          </div>
          <VueSlider
            ref="slider"
            v-model="hierarchyFilter"
            v-bind="sliderProps"
            style="padding:1px;margin-top: 30px"
          />
        </div>
        <div v-if="viewMode === 1" class="filter-option generic-border--thin-border">
          <div class="legend">
            {{ $t('message.FILTER_BY_TEAM') }}
          </div>
          <AdvancedTeamPicker
            v-model="filteredTeamIds"
            legend=""
            display-all-teams
            field-teams-number
            config
          />
          <div class="sep sep--centered" />
          <Checkbox v-model="displayTeamlessUsers" :title="$t('message.CONFIG_DISPLAY_TEAMLESS_USERS')" />
        </div>
        <div v-if="viewMode === 1" class="filter-option generic-border--thin-border">
          <Checkbox v-model="displayAdminOnly" :title="$t('message.CONFIG_DISPLAY_ADMINS_ONLY')" />
        </div>

        <div v-if="viewMode === 0">
          <h2 class="basic-sub-title">
            {{ $t('message.CONFIG_HIERARCHY_TREE') }}
          </h2>
          <div v-if="viewMode === 0" class="filter-option teams__hierarchy-tree generic-border--thin-border">
            <div class="teams__hierarchy-tree__options">
              <Checkbox v-model="displayHierarchyTree" :title="$t('message.CONFIG_DISPLAY_HIERARCHY_TREE')" />
              <div v-if="displayHierarchyTree" class="field-hint" v-html="$t('message.CONFIG_HIERARCHY_TREE_HINT')" />
            </div>
            <AdvancedTeamPickerTree
              v-if="displayHierarchyTree"
              :value="[]"
              display-all-teams
              config
              for-display-only
              allow-change-hierarchy
              @hierarchyChange="editTeamHierarchy"
            />
          </div>
        </div>
      </div>
      <div ref="usersContainer" class="users-content f-h generic-border">
        <div class="users-content-header-options">
          <div class="users-content-header-options__select v-centerer">
            <span>
              <span v-if="viewMode === 0">
                {{ $tc('message.N_TEAMS', teams.length, { n: teams.length }) }}
              </span>
              <span v-else>
                {{ $tc('message.N_USERS', users.length, { n: users.length }) }}
              </span>
            </span>
            <span class="option-link" @click="selectAll()">
              <span>{{ selectedItems.length > 0 ? $t('message.UNSELECT_ALL') : $t('message.SELECT_ALL') }}</span>
            </span>
          </div>
          <input
            ref="importInput"
            type="file"
            accept=".xls,.xlsx,.xlsm,.csv"
            style="display:none;"
            @change="importFile()"
          >
          <a ref="downloadLink" download="template.xlsx" style="display:none;" />
          <div v-if="viewMode === 1">
            <button class="add-button blue" @click="triggerImport()">
              <Icon>{{ Icons.uploadCloud }}</Icon>
              <span>{{ $t('message.IMPORT_XLSX') }}</span>
            </button>
            <button class="add-button blue" @click="downloadTemplate()">
              {{ $t('message.DOWNLOAD_XLSX_TEMPLATE') }}
            </button><br>
            <button class="add-button blue" @click="exportUsers()">
              <Icon>{{ Icons.downloadMedium }}</Icon>
              <span>{{ $t('message.EXPORT_TO_EXCEL') }}</span>
            </button><br>
            <button class="add-button blue" @click="newUser()">
              <Icon>{{ Icons.addCircleMedium }}</Icon>
              <span>{{ $t('message.NEW_USER') }}</span>
            </button>
          </div>
          <button v-else class="add-button blue" @click="newTeam()">
            <Icon>{{ Icons.addCircleMedium }}</Icon>
            <span>{{ $t('message.NEW_TEAM') }}</span>
          </button>
        </div>
        <RecycleScroller
          v-slot="{ item }"
          class="users-content-scroller"
          :items="filteredItems"
          :item-size="itemHeight"
          key-field="id"
        >
          <div class="user-item v-centerer">
            <div
              class="small-card-item v-centerer"
              :class="{ selected: item.selected }"
              @click="selectUser(item)"
            >
              <span class="dot" :style="'background-color:' + colors[item.hierarchyLevel % colors.length].dark" />
              <Icon v-if="item.locked" v-quick-title="" class="small-card-item__lock">
                {{ Icons.lockMedium }}
              </Icon>
              <span v-if="viewMode === 1" class="name" :class="{ 'greyed-out': item.locked }">
                {{ $t('fullNameFormat', item) }}
              </span>
              <span v-if="viewMode === 1" class="team ml5">
                {{ $t('message.CONTENT_BETWEEN_PARENTHESES', { content: item.teamName }) }}
              </span>
              <span
                v-if="viewMode === 0"
                class="name"
                :class="{ 'greyed-out': item.locked }"
                v-html="item.name"
              />
              <span v-if="viewMode === 0">
                {{ $t('message.ID') + $t('message.TWO_DOTS') + item.id + '-' + item.strId }}
              </span>
              <span
                v-if="viewMode === 1 && item.eraseRequest"
                v-quick-title="$t(
                  'message.USER_DATA_REMOVAL_DATE',
                  { date: $moment(item.eraseRequest).format($t('minDateFormat')) },
                )"
                class="erase-warning h-v-centerer"
              >
                <Icon>{{ Icons.warningMedium }}</Icon>
              </span>
            </div>
            <div class="user-item-actions">
              <Icon @click.native="editItem(item)">{{ Icons.editMedium }}</Icon>
              <Icon class="delete" @click.native="deleteItem([item.id])">{{ Icons.deleteMedium }}</Icon>
            </div>
          </div>
        </RecycleScroller>
      </div>
      <div
        v-show="indicsEdition.show || plansEdition.show"
        class="f-h f-w config-settings-wrapper"
      >
        <CloseButton style="left: 10px;" @click.native="cancelMassEdit()" />
        <SchemesList
          v-show="indicsEdition.show"
          :disabled="true"
          :schemes="schemes"
          @schemeClick="saveIndicators"
        />
      </div>
    </div>

    <!-- Edition modal -->
    <ConfigEditionModal
      v-if="editedItem != null"
      :value="editedItem"
      :is-team="viewMode === 0"
      :all-users="users"
      @input="updateItem"
    />

    <transition name="fade" mode="out-in">
      <div
        v-if="affectingUsers || copyingTeamIndicators"
        class="dark-overlay v-centerer"
        style="text-align: left"
      >
        <div class="dark-overlay-content users-content" style="padding: 30px;box-sizing: border-box;">
          <CloseButton style="left: 10px;" @click.native="assignAllTo(null)" />
          <div
            v-for="item in teams"
            :key="item.id"
            class="user-item v-centerer"
          >
            <div class="small-card-item v-centerer" @click="assignAllTo(item)">
              <span class="dot" :style="'background-color:' + colors[item.hierarchyLevel % colors.length].dark" />
              <span class="name" v-html="item.name" />
            </div>
          </div>
        </div>
      </div>
    </transition>

    <EditableLabelRadio
      ref="actionPlansSelection"
      v-model="actionPlansSelection"
      :items="actionPlansTemplates"
      multiple
      no-text
      ok-button
      @ok="assignActionPlans"
    />

    <Modal v-model="assigningCfgPages">
      <ConfigurablePagesList selection @ok="addCfgPages" />
    </Modal>

    <Modal v-model="assigningMeetings">
      <MeetingTemplatesList @ok="addMeetings" />
    </Modal>

    <Modal v-model="assigningTemplates" xlarge>
      <StartupTemplatesEdition @ok="applyTemplates" />
    </Modal>

    <LoadingOverlay :value="sendUserEmailLoading" :text="$t('message.CONFIG_UPDATE_SENDING_USER_EMAIL')" />
  </div>
</template>

<script>
import { cloneDeep, isEqual } from 'lodash';
import $ from 'jquery';
import toastr from 'toastr';
import XLSX from 'xlsx';
import { mapState } from 'vuex';
// Vuex
import { RecycleScroller } from 'vue-virtual-scroller';
import VueSlider from 'vue-slider-component';
import { FETCH_TEAMS, FETCH_ACTION_PLANS } from '@/store/action-types';
import { GET_TEAMS } from '@/store/mutation-types';
import storeActions from '@/store/modules/config/action-types';
import { GET_SCHEMES, GET_CONFIG_ACTION_PLANS, GET_CONFIG_USERS } from '@/store/modules/config/mutation-types';
import { FETCH_PLANNINGS } from '@/store/modules/meeting/action-types';
import { GET_PLANNINGS } from '@/store/modules/meeting/mutation-types';
// Components
import AdvancedTeamPicker from '@/components/advanced-team-picker.vue';
import AdvancedTeamPickerTree from '@/components/advanced-team-picker-tree.vue';
import Checkbox from '@/components/checkbox.vue';
import CloseButton from '@/components/close-button.vue';
import ConfigEditionModal from '@/components/config-edition-modal.vue';
import ConfigurablePagesList from '@/components/configurable-pages-list.vue';
import EditableLabelRadio from '@/components/editable-label-radio.vue';
import Icon from '@/components/icon.vue';
import LeftDrawerPanel from '@/components/left-drawer-panel.vue';
import LoadingOverlay from '@/components/loading-overlay.vue';
import MeetingTemplatesList from '@/components/meeting-templates-list.vue';
import Modal from '@/components/modal.vue';
import RadioGroup from '@/components/radio-group.vue';
import SchemesList from '@/components/schemes-list.vue';
import StartupTemplatesEdition from '@/components/startup-templates-edition.vue';
import Switcher from '@/components/switcher.vue';
// Mixins
import mixinConfigPages from '@/mixins/config-pages.vue';
// Utils
import { hierarchyColors } from '@/utils/config-utils';
import { ROLE_ADMIN } from '@/utils/constants';
import { calert, sliderProperties } from '@/utils/main';
import * as Icons from '@/assets/icons';
import { exportUsersToExcel } from '@/utils/team-utils';

export default {

  name: 'ConfigTeams',

  components: {
    AdvancedTeamPicker,
    AdvancedTeamPickerTree,
    Checkbox,
    CloseButton,
    ConfigEditionModal,
    ConfigurablePagesList,
    EditableLabelRadio,
    Icon,
    LeftDrawerPanel,
    LoadingOverlay,
    MeetingTemplatesList,
    Modal,
    RadioGroup,
    RecycleScroller,
    SchemesList,
    StartupTemplatesEdition,
    Switcher,
    VueSlider,
  },

  mixins: [mixinConfigPages],

  data() {
    return {
      Icons,
      colors: hierarchyColors,
      viewModeTitles: [this.$t('message.TEAMS'), this.$t('message.USERS')],
      // Filters
      minHL: 0,
      displayHierarchyTree: false,
      search: '',
      // Main data
      teams: [],
      users: [],
      // Editing a team / user
      editedItem: null,
      ongoingItemEdit: false,
      itemBeforeEdit: null,
      affectingUsers: false,
      indicsEdition: { show: false, teams: [] },
      copyingTeamIndicators: false,
      workingDaysEdition: {
        val: [],
        data: [
          { id: 0, title: this.$t('message.MONDAY') },
          { id: 1, title: this.$t('message.TUESDAY') },
          { id: 2, title: this.$t('message.WEDNESDAY') },
          { id: 3, title: this.$t('message.THURSDAY') },
          { id: 4, title: this.$t('message.FRIDAY') },
          { id: 5, title: this.$t('message.SATURDAY') },
          { id: 6, title: this.$t('message.SUNDAY') },
        ],
      },
      plansEdition: { show: false, teams: [] },
      assigningMeetings: false,
      assigningCfgPages: false,
      assigningTemplates: false,
      actionPlansSelection: [],
      // Properties used by other components. See src/views/readme.md
      pageTitle: this.$t('message.TEAMS'),
      ROLE_ADMIN,
    };
  },

  computed: {
    maxHL() {
      return this.stateTeams.length ? Math.max(...this.stateTeams.map(t => t.hierarchyLevel)) : 0;
    },
    /** Number: Height in pixels of each user/team item */
    itemHeight() {
      return this.$store.getters.fontSize * 3.4;
    },
    /** Hierarchy level filter slider properties */
    sliderProps() {
      const slider = Object.assign({}, sliderProperties);
      slider.width = '100%';
      slider.piecewise = true;
      slider.min = this.minHL;
      slider.max = this.maxHL;
      slider.interval = 1;
      slider.height = 5;
      return slider;
    },
    /** Users array after applying filters and sort options */
    filteredItems() {
      const array = this.viewMode === 0 ? this.teams : this.users;
      const nameKey = this.viewMode === 0 ? 'name' : 'lastName';
      // Filter
      const effectiveSearch = this.search.sAccentless.toUpperCase().split(/[\s,-./']/);
      const output = array.filter((item) => {
        if (this.viewMode === 1
          && this.filteredTeamIds.indexOf(item.team) < 0
          && (item.team !== null || !this.displayTeamlessUsers)
        ) {
          return false;
        }

        if (this.viewMode === 1 && this.displayAdminOnly && !item.roles.includes(ROLE_ADMIN)) {
          return false;
        }

        const [min, max] = this.hierarchyFilter;
        if (min > item.hierarchyLevel || max < item.hierarchyLevel) {
          return false;
        }

        if (effectiveSearch.some(term => !item.name.sAccentless.toUpperCase().includes(term))) {
          if (this.viewMode === 1) {
            // For users, also search in email, ssoId, companyInternalId
            const noSearchMatch = effectiveSearch.some(term => (!item.email || !item.email.toUpperCase().includes(term))
                && (!item.companyInternalId || !item.companyInternalId.toUpperCase().includes(term))
                && (!item.ssoId || !item.ssoId.toUpperCase().includes(term)));
            if (noSearchMatch) {
              return false;
            }
          } else {
            // For teams, only search in name
            return false;
          }
        }
        return true;
      });
      // Sort
      switch (this.sortBy.value) {
        case 0:
          return !this.sortBy.desc
            ? output.sort((a, b) => String(a[nameKey]).localeCompare(b[nameKey]))
            : output.sort((a, b) => String(b[nameKey]).localeCompare(a[nameKey]));
        case 1:
          return !this.sortBy.desc
            ? output.sort((a, b) => a.hierarchyLevel - b.hierarchyLevel)
            : output.sort((a, b) => b.hierarchyLevel - a.hierarchyLevel);
        case 2:
          return !this.sortBy.desc
            ? output.sort((a, b) => a.createdSortable - b.createdSortable)
            : output.sort((a, b) => b.createdSortable - a.createdSortable);
        default:
          return output;
      }
    },
    /** Array of selected teams / users */
    selectedItems() {
      const array = this.viewMode === 0 ? this.teams : this.users;
      return array.filter(item => item.selected);
    },
    /** Array of selected teams / users ids */
    selectedItemsIds() {
      return this.selectedItems.map(item => item.id);
    },
    sortItems() {
      return [
        { id: 0, label: this.$t('message.SORT_AZ') },
        { id: 1, label: this.$t('message.SORT_BY_LEVEL') },
        { id: 2, label: this.$t('message.SORT_BY_CREATION_DATE') },
      ];
    },
    /** Array: Action plan templates available to assign to teams */
    actionPlansTemplates() {
      return this.actionPlans.map(plan => ({ ...plan, label: plan.name }));
    },
    ...mapState({
      stateTeams: state => state[GET_TEAMS.stateKey] || [],
      stateTeamsLoading: state => state[GET_TEAMS.loadingKey],
    }),
    ...mapState('meeting', {
      planningsLoading: state => state[GET_PLANNINGS.loadingKey],
    }),
    ...mapState('config', {
      schemes: state => state[GET_SCHEMES.stateKey] || [],
      schemesLoading: state => state[GET_SCHEMES.loadingKey],
      sendUserEmailLoading: state => state.sendUserEmailLoading,
      actionPlans: state => state[GET_CONFIG_ACTION_PLANS.stateKey] || [],
      actionPlansLoading: state => state[GET_CONFIG_ACTION_PLANS.loadingKey],
      stateUsers: state => state[GET_CONFIG_USERS.stateKey] || [],
      stateUsersLoading: state => state[GET_CONFIG_USERS.loadingKey],
    }),
    // ============
    // Query params
    // ============
    // Show teams (0) or users (1)
    viewMode: {
      get() {
        if (this.$route.query.viewMode !== undefined) {
          const viewMode = Number(this.$route.query.viewMode).sBetweenBoundaries(0, 1);
          return viewMode;
        }
        return 0;
      },
      set(mode) {
        mode = Number(mode).sBetweenBoundaries(0, 1);
        const query = Object.assign({}, this.$route.query);
        query.viewMode = mode;
        if (!isEqual(query, this.$route.query)) {
          this.$router.replace({ query });
        }
      },
    },
    // Srt users or teams
    sortBy: {
      get() {
        let sortBy = 0;
        const sortDesc = this.$route.query.sortDesc === 'true';
        if (this.$route.query.sortBy !== undefined) {
          sortBy = Number(this.$route.query.sortBy).sBetweenBoundaries(0, this.sortItems.length - 1);
        }
        return { value: sortBy, desc: sortDesc };
      },
      set(sortBy) {
        if (sortBy.value !== undefined && sortBy.desc !== undefined) {
          const query = Object.assign({}, this.$route.query);
          query.sortDesc = sortBy.desc ? 'true' : 'false';
          query.sortBy = Number(sortBy.value).sBetweenBoundaries(0, this.sortItems.length - 1);
          if (!isEqual(query, this.$route.query)) {
            this.$router.replace({ query });
          }
        }
      },
    },
    // Filter users or teams using hierarchy level
    hierarchyFilter: {
      get() {
        const { minHL, maxHL } = this;
        let { hierarchyFilter } = this.$route.query;
        if (hierarchyFilter !== undefined) {
          hierarchyFilter = hierarchyFilter.split(',').map(val => Number(val).sBetweenBoundaries(minHL, maxHL));
          if (hierarchyFilter[0] > hierarchyFilter[1]) {
            // eslint-disable-next-line prefer-destructuring
            hierarchyFilter[0] = hierarchyFilter[1];
          }
          return hierarchyFilter;
        }
        return [minHL, maxHL];
      },
      set(hierarchyFilter) {
        if (this.teams && this.teams.length > 0 && hierarchyFilter instanceof Array && hierarchyFilter.length === 2) {
          hierarchyFilter = hierarchyFilter.map(val => Number(val).sBetweenBoundaries(this.minHL, this.maxHL));
          if (hierarchyFilter[0] > hierarchyFilter[1]) {
            // eslint-disable-next-line prefer-destructuring
            hierarchyFilter[0] = hierarchyFilter[1];
          }
          const query = Object.assign({}, this.$route.query);
          query.hierarchyFilter = hierarchyFilter.join(',');
          if (!isEqual(query, this.$route.query)) {
            this.$router.replace({ query });
          }
        }
      },
    },
    // Filter users using team ids
    filteredTeamIds: {
      get() {
        const { filterTeams } = this.$route.query;
        if (filterTeams !== undefined) {
          let teams = filterTeams.split(',');
          if (teams) {
            teams = teams.map(id => Number(id));
            const ids = teams.filter(id => this.teams.map(t => t.id).includes(id));
            return ids;
          }
        }
        return this.teams.map(t => t.id);
      },
      set(teams) {
        const query = Object.assign({}, this.$route.query);
        query.filterTeams = teams
          ? teams.filter(id => this.teams.map(t => t.id).includes(id)).join(',')
          : undefined;
        if (!isEqual(query, this.$route.query)) {
          this.$router.replace({ query });
        }
      },
    },
    /** Boolean: Whether to display users without a reference team or not */
    displayTeamlessUsers: {
      get() {
        return this.$route.query.displayTeamlessUsers === 'true';
      },
      set(display) {
        const query = Object.assign({}, this.$route.query);
        query.displayTeamlessUsers = display ? 'true' : undefined;
        if (!isEqual(query, this.$route.query)) {
          this.$router.replace({ query });
        }
      },
    },
    /** Boolean: Whether to filter out all sers who are not admins */
    displayAdminOnly: {
      get() {
        return this.$route.query.displayAdminOnly === 'true';
      },
      set(display) {
        const query = Object.assign({}, this.$route.query);
        query.displayAdminOnly = display ? 'true' : undefined;
        if (!isEqual(query, this.$route.query)) {
          this.$router.replace({ query });
        }
      },
    },
  },

  watch: {
    stateTeams(teams) {
      this.teams = cloneDeep(teams).map(t => ({ ...t, selected: false }));
    },
    stateUsers(users) {
      this.users = cloneDeep(users).map(u => ({ ...u, name: this.$t('fullNameFormat', u), selected: false }));
    },
  },

  beforeRouteLeave(to, from, next) {
    if (this.plansEdition.show || this.indicsEdition.show
      || this.copyingTeamIndicators || this.editedItem != null || this.affectingUsers
    ) {
      calert(this.$t('message.LEAVING_CHANGES_BEHIND'), [
        { title: this.$t('message.EXIT_WITHOUT_SAVING'), action: next },
        { title: this.$t('message.CANCEL') },
      ]);
    } else {
      next();
    }
  },

  methods: {
    cancelMassEdit() {
      if (this.indicsEdition.show) {
        this.indicsEdition.show = false;
      }
      if (this.plansEdition.show) {
        this.plansEdition.show = false;
        this.$refs.configPlans.plans = [];
      }
    },
    /** Create a scheme or copy setting of another team */
    configIndicators() {
      // Display current setup of selected teams
      const schemes = {};
      let currentSetup = '';
      let index;
      let multiple;
      let teamsString;
      const andSeparator = this.$t('message.CONFIG_ENUM_LAST_SEP');
      const comma = this.$t('message.CONFIG_ENUM_SEP');
      for (let i = 0, len = this.selectedItems.length; i < len; i++) {
        if (this.selectedItems[i].indicatorsScheme) {
          index = `${this.selectedItems[i].indicatorsScheme}`;
          if (typeof schemes[index] === 'undefined') {
            schemes[index] = [];
          }
          schemes[index].push(this.selectedItems[i]);
        }
      }

      Object.keys(schemes).forEach((id) => {
        const scheme = schemes[id];
        multiple = scheme.length > 1;
        teamsString = '';
        const names = scheme.map(o => `<b>${o.name}</b>`);
        if (multiple) {
          teamsString = names.slice(0, -1).join(comma) + andSeparator + names.slice(-1);
          currentSetup += Number(scheme[0].indicatorsScheme) === 0
            ? this.$t('message.CONFIG_CURRENT_NOSCHEME_PLUR', { teams: teamsString })
            : this.$t('message.CONFIG_CURRENT_SCHEME_PLUR', {
              teams: teamsString,
              schemeName: `<b>${scheme[0].isName}</b>`,
            });
        } else {
          currentSetup += Number(scheme[0].indicatorsScheme) === 0
            ? this.$t('message.CONFIG_CURRENT_NOSCHEME', { team: names[0] })
            : this.$t('message.CONFIG_CURRENT_SCHEME', { team: names[0], schemeName: `<b>${scheme[0].isName}</b>` });
        }
        currentSetup += '<br/>';
      });
      currentSetup += '<br/>';

      calert(currentSetup + this.$t('message.CONFIG_INDICATOR_CHOICES'), [
        { title: this.$t('message.CONFIG_CHOOSE_TEMPLATE'), action: this.setIndicators },
        {
          title: this.$t('message.COPY_SETTINGS_FROM_OTHER_TEAM'),
          action: () => {
            this.copyingTeamIndicators = true;
          },
        },
        { title: this.$t('message.CONFIG_DELETE_INDICATORS'), action: this.deleteIndicators, sClass: 'red' },
        { title: this.$t('message.CANCEL') },
      ]);
    },
    setIndicators() {
      this.indicsEdition.show = true;
      this.indicsEdition.teams = this.selectedItemsIds;
      this.selectAll();
    },
    copyIndicatorsFrom(team) {
      this.copyingTeamIndicators = false;
      this.App.post('/server/config/setIndicators.php', { copy: team.id, teams: this.selectedItemsIds }, (d) => {
        if (d === 1) {
          toastr.success(this.$t('message.TEAMS_UPDATED'));
          this.refresh();
        } else {
          toastr.error(this.$t('message.CONNECTION_ERROR'));
        }
      });
    },
    /** Back from indicators edition */
    saveIndicators(scheme) {
      // Option to create indicators without a scheme has been removed in 0.2.2.
      // So scheme is always true. See commit of 2018-12-14
      this.App.post('/server/config/setIndicators.php', { teams: this.indicsEdition.teams, scheme: scheme.id }, (d) => {
        if (d === 1) {
          toastr.success(this.$t('message.TEAMS_UPDATED'));
          this.indicsEdition.show = false;
          this.refresh();
        } else {
          toastr.error(this.$t('message.CONNECTION_ERROR'));
        }
      });
    },
    /** Completely remove the indicators for this team */
    deleteIndicators() {
      this.App.post('/server/config/deleteIndicators.php', { teams: this.selectedItemsIds }, (d) => {
        if (d === 1) {
          toastr.success(this.$t('message.TEAMS_UPDATED'));
          this.refresh();
        } else {
          toastr.error(this.$t('message.CONNECTION_ERROR'));
        }
      });
    },
    /** Set the working days of the selected teams */
    configWorkingDays() {
      if (this.selectedItemsIds.length) {
        const wds = [];
        for (let i = 0, len = this.selectedItems.length; i < len || wds.length === 7; i++) {
          const wd = this.selectedItems[i].workingDays;
          const jlen = wd.length;
          for (let j = 0; j < jlen || wds.length === 7; j++) {
            if (wds.indexOf(wd[j]) === -1) {
              wds.push(wd[j]);
            }
          }
        }
        this.workingDaysEdition.val = wds;
        this.$refs.wdEdit.edit();
      }
    },
    /** Back from working days edition */
    workingDaysEdited() {
      this.$http.post('/server/config/updateTeamParams.php', {
        teams: this.selectedItemsIds,
        workingDays: JSON.stringify(this.workingDaysEdition.val),
      }).then((response) => {
        if (response && response.data === 1) {
          toastr.success(this.$t('message.TEAMS_UPDATED'));
          this.$refs.wdEdit.stopEdit();
          this.refresh();
          this.workingDaysEdition.val = [];
        } else {
          toastr.error(this.$t('message.CONNECTION_ERROR'));
        }
      });
    },
    /** Assign plan templates to teams */
    assignActionPlans() {
      // Close the radio options on 'ok'
      if (this.$refs.actionPlansSelection && this.$refs.actionPlansSelection.stopEdit instanceof Function) {
        this.$refs.actionPlansSelection.stopEdit();
      }
      const params = { plans: this.actionPlansSelection, teams: this.selectedItemsIds };
      this.$http.post('/server/actionPlans/assign.php', params).then((response) => {
        if (response && response.data === 1) {
          toastr.success(this.$t('message.TEAMS_UPDATED'));
        } else {
          toastr.error(this.$t('message.CONNECTION_ERROR'));
        }
      });
    },
    /** Assign some configurable pages to some teams */
    addCfgPages(pages) {
      this.$http.post('/server/customPages/assign.php', { pages, teams: this.selectedItemsIds }).then((response) => {
        if (response && response.data === 1) {
          this.assigningCfgPages = false;
          toastr.success(this.$t('message.TEAMS_UPDATED'));
        } else {
          toastr.error(this.$t('message.CONNECTION_ERROR'));
        }
      });
    },
    /** Assign some meetings to some teams */
    addMeetings(templates) {
      const params = { templates, teams: this.selectedItemsIds };
      this.$http.post('/server/meetings/plannings/assign.php', params).then((response) => {
        if (response && response.data === 1) {
          this.assigningMeetings = false;
          toastr.success(this.$t('message.TEAMS_UPDATED'));
        } else {
          toastr.error(this.$t('message.CONNECTION_ERROR'));
        }
      });
    },
    /** Assign startup templates to some teams */
    applyTemplates(templates) {
      const params = { templates: templates.map(t => t.id), teams: this.selectedItemsIds };
      this.$http.post('/server/config/startup-templates/assign.php', params).then((response) => {
        if (response && response.data === 1) {
          this.assigningTemplates = false;
          toastr.success(this.$t('message.TEAMS_UPDATED'));
        } else {
          toastr.error(this.$t('message.CONNECTION_ERROR'));
        }
      });
    },
    /** Refresh the list of users and teams */
    refresh() {
      if (!this.stateTeamsLoading) {
        this.$store.dispatch(FETCH_TEAMS, { config: 1 });
      }
      if (!this.stateUsersLoading) {
        this.$store.dispatch(`config/${storeActions.FETCH_CONFIG_USERS}`);
      }
      if (!this.actionPlansLoading) {
        this.$store.dispatch(FETCH_ACTION_PLANS, { config: 1 });
      }
      if (!this.schemesLoading) {
        this.$store.dispatch(`config/${storeActions.FETCH_SCHEMES}`, { config: 1 });
      }
      if (!this.planningsLoading) {
        this.$store.dispatch(`meeting/${FETCH_PLANNINGS}`);
      }
    },
    /** Add a new team item to the list and trigger the edition modal */
    newTeam() {
      this.teams.push({
        id: 0,
        name: '',
        email: '',
        hierarchyLevel: 0,
        users: [],
        supervisorTeamIds: [],
        supervisedTeamIds: [],
      });
      this.editItem(this.teams[this.teams.length - 1]);
    },
    /** Add a new user item to the list and trigger the edition modal */
    newUser() {
      this.users.push({
        id: 0,
        firstName: '',
        lastName: '',
        team: 0,
        hierarchyLevel: 0,
        teams: [],
        accesses: [],
      });
      this.editItem(this.users[this.users.length - 1]);
    },
    /** Select the user to use actions */
    selectUser(user) {
      user.selected = !user.selected;
    },
    /** Select / Unselect all displayed users */
    selectAll() {
      const select = this.selectedItems.length === 0;
      for (let i = 0, len = this.filteredItems.length; i < len; i++) {
        this.filteredItems[i].selected = select;
      }
    },
    /** Edit a specific user/team in a modal */
    editItem(item) {
      this.editedItem = item;
      // Allow reverting changes
      this.itemBeforeEdit = Object.assign({}, item);
    },
    /** Update current team / user to server */
    updateItem(value) {
      if (value === null) {
        if (this.editedItem.id === 0) {
          const array = this.viewMode === 0 ? this.teams : this.users;
          array.splice(array.indexOf(this.editedItem), 1);
        } else {
          Object.keys(this.editedItem).forEach((key) => {
            this.editedItem[key] = this.itemBeforeEdit[key];
          });
        }
        this.editedItem = null;
        return;
      }
      if (this.viewMode === 0 && this.editedItem.id === 0 && !/\S+@\S+\.\S+/.test(this.editedItem.email)) {
        // No email set
        calert(this.$t('message.CONFIG_CONFIRM_NO_EMAIL'), [
          { title: this.$t('message.OK'), action: this.confirmUpdateItem },
          { title: this.$t('message.CANCEL') },
        ]);
      } else if (this.viewMode === 1 && !this.editedItem.team) {
        calert(this.$t('message.CONFIG_USER_MUST_HAVE_TEAM'));
      } else {
        this.confirmUpdateItem();
      }
    },
    /** Send the updated team/user to the server */
    confirmUpdateItem() {
      if (this.ongoingItemEdit) {
        return;
      }
      const action = this.viewMode === 1 ? storeActions.EDIT_USER : storeActions.EDIT_TEAM;
      const params = Object.assign({ locale: this.$t('min') }, this.editedItem);
      this.ongoingItemEdit = true;
      this.$store.dispatch(`config/${action}`, params)
        .then(() => {
          this.editedItem = null;
          this.ongoingItemEdit = false;
        })
        .catch(() => {
          this.ongoingItemEdit = false;
        });
    },
    /** Handle the hierarchyChange event from AdvancedTeamPickerTree */
    editTeamHierarchy(params) {
      const { childTeamId, parentTeamId, fromParentTeamId } = params;
      const team = this.stateTeams.find(t => t.id === childTeamId);
      if (team) {
        const paramTeam = cloneDeep(team);
        const oldSupervisorIndex = paramTeam.supervisorTeamIds.indexOf(fromParentTeamId);
        if (oldSupervisorIndex >= 0) {
          paramTeam.supervisorTeamIds.splice(oldSupervisorIndex, 1);
        }
        paramTeam.supervisorTeamIds.push(parentTeamId);
        this.$store.dispatch(`config/${storeActions.EDIT_TEAM}`, paramTeam);
      }
    },
    /** Prompts confirmation to the user for deleting teams or users */
    deleteItem(itemIds) {
      const msg = this.viewMode === 0
        ? this.$t('message.CONFIRM_DELETE_TEAMS')
        : this.$t('message.CONFIRM_DELETE_USERS');
      calert(msg, [
        { title: this.$t('message.REMOVE'), action: () => { this.confirmDeleteItem(itemIds); }, sClass: 'red' },
        { title: this.$t('message.CANCEL') },
      ]);
    },
    /** Sends an XHR to delete a team or a user */
    confirmDeleteItem(items) {
      const action = `config/${this.viewMode === 1 ? storeActions.DELETE_USERS : storeActions.DELETE_TEAMS}`;
      this.$store.dispatch(action, { items });
    },
    promptEraseUserData(user) {
      calert(this.$t('message.CONFIRM_ERASE_USER_DATA'), [
        {
          title: this.$t('message.ERASE'),
          sClass: 'red',
          action: () => { this.eraseUserData(user); },
        },
        { title: this.$t('message.CANCEL') },
      ]);
    },
    eraseUserData(user) {
      this.App.post('/server/config/eraseUserInfo.php', { id: user.id }, (data) => {
        if (data !== 1) {
          toastr.error(this.$t('message.CONNECTION_ERROR'));
          return;
        }
        toastr.success(this.$t('message.SAVED'));
        this.refresh();
      });
    },
    /**
     * Remove erase deadline of a user
     */
    cancelEraseUserData(user) {
      this.App.post(
        '/server/config/deleteEraseRequest.php',
        { id: user.id },
        (data) => {
          if (data !== 1) {
            toastr.error(this.$t('message.CONNECTION_ERROR'));
            return;
          }
          toastr.success(this.$t('message.SAVED'));
          this.refresh();
        },
      );
    },
    /** Display teams to assign all selected users to one */
    assignSelected() {
      if (this.selectedItems.length) {
        this.affectingUsers = true;
      }
    },
    /** Select a team to affect all users currently selected */
    assignAllTo(team) {
      // TODO: Use users/utils
      if (!this.affectingUsers) {
        if (this.copyingTeamIndicators) {
          this.copyIndicatorsFrom(team);
        }
        return;
      }
      if (team) {
        const us = [];
        for (let i = 0, len = this.selectedItems.length; i < len; i++) {
          us.push(this.selectedItems[i].id);
        }
        this.App.post('/server/config/assignAll.php', { users: us, team: team.id }, (d) => {
          if (d === 1) {
            toastr.success(this.$t('message.USERS_UPDATED'));
            this.refresh();
          } else {
            toastr.error(this.$t('message.CONNECTION_ERROR'));
          }
        });
      }
      this.selectAll();
      this.affectingUsers = false;
    },
    /** Meant to allow any type of excel import assuming that the template is respected */
    triggerImport() {
      $(this.$refs.importInput).trigger('click');
    },
    /** Download a basic .xlsx template to import users */
    downloadTemplate() {
      // Add existing teams
      const tstr = this.$t('message.ALREADY_CREATED_TEAMS');
      const teams = [];
      for (let i = 0, len = this.teams.length; i < len; i++) {
        teams.push({});
        teams[i][tstr] = this.teams[i].name;
      }
      // Create WorkBook
      const wb = XLSX.utils.book_new();
      const ws = XLSX.utils.json_to_sheet(teams, {
        header: [
          this.$t('message.FIRST_NAME'),
          this.$t('message.LAST_NAME'),
          this.$t('message.TEAM'),
          this.$t('message.EMAIL'),
          this.$t('message.USERNAME'),
          this.$t('message.CONFIG_USER_SSO_ID'),
          '',
          tstr,
        ],
      });
      XLSX.utils.book_append_sheet(wb, ws, this.$t('message.USERS'));
      const wbout = XLSX.write(wb, { bookType: 'xlsx', bookSST: false, type: 'base64' });
      // Download workbook
      const a = document.createElement('a');
      document.body.appendChild(a);
      a.download = 'template.xlsx';
      a.href = `data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,${wbout}`;
      a.click();
      a.remove();
    },
    /** Fetch and parse .xlsx file */
    importFile() {
      const file = this.$refs.importInput.files[0];
      this.$refs.importInput.value = '';
      this.$store.dispatch(`config/${storeActions.ADD_USERS}`, { file });
    },
    /** Reset users crdentials and send them new ones */
    sendUsersCredentials(userIds) {
      calert(this.$t('message.CONFIG_SEND_CREDENTIALS_CONFIRM'), [
        {
          title: this.$t('message.CONFIG_RESET_AND_SEND_CREDENTIALS'),
          action: () => {
            this.$store.dispatch(`config/${storeActions.SEND_USERS_CREDENTIALS}`, { users: userIds });
          },
        },
        { title: this.$t('message.CANCEL') },
      ]);
    },
    /** Lock user out of their account */
    lockUsers(userIds, doLock) {
      const confirmStr = doLock
        ? this.$t('message.CONFIG_DISABLE_ACCOUNT_CONFIRM')
        : this.$t('message.CONFIG_ENABLE_ACCOUNT_CONFIRM');
      const buttonStr = doLock
        ? this.$t('message.CONFIG_DISABLE_ACCOUNT')
        : this.$t('message.CONFIG_ENABLE_ACCOUNT');
      calert(confirmStr, [
        {
          title: buttonStr,
          action: () => {
            this.$store.dispatch(`config/${storeActions.LOCK_USERS}`, { users: userIds, lock: doLock ? 1 : 0 });
          },
          sClass: 'red',
        },
        { title: this.$t('message.CANCEL') },
      ]);
    },
    /** Lock team accounts */
    lockTeams(teams, doLock) {
      const confirmStr = doLock
        ? this.$t('message.CONFIG_DISABLE_ACCOUNT_CONFIRM')
        : this.$t('message.CONFIG_ENABLE_ACCOUNT_CONFIRM');
      const buttonStr = doLock
        ? this.$t('message.CONFIG_DISABLE_ACCOUNT')
        : this.$t('message.CONFIG_ENABLE_ACCOUNT');
      calert(confirmStr, [
        {
          title: buttonStr,
          action: () => {
            this.$store.dispatch(`config/${storeActions.LOCK_TEAMS}`, { teams, lock: doLock ? 1 : 0 });
          },
          sClass: 'red',
        },
        { title: this.$t('message.CANCEL') },
      ]);
    },
    /**
     * This is a custom feature for our customer 'Mines Production'
     * It allows the admin to reset the account of team ID = 101546.
     */
    resetDiwiiAccount() {
      this.$http.post('/server/api/customerLinks/mines/reset.php')
        .then((response) => {
          if (response.data && response.data instanceof Object && response.data.code === 1) {
            toastr.success(this.$t('message.RESET_SUCCESS'));
          }
        })
        .catch(() => {
          toastr.error(this.$t('message.CONNECTION_ERROR'));
        });
    },
    /** Export user list as excel file * */
    exportUsers() {
      this.$http.get('/server/users/export')
        .then(({ data }) => {
          exportUsersToExcel(data);
        })
        .catch(() => {
          toastr.error(this.$t('message.CONNECTION_ERROR'));
        });
    },
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/vars.scss";

.config-teams {

  .f-h-below-title {
    box-sizing: border-box;
    position: relative;
  }

  .filters, .users-content {
    display: inline-block;
    white-space: normal;
    vertical-align: top;
    overflow-y: auto;
    overflow-x: hidden;
  }

  .filters {
    width: 24%;
    padding: 0 0.5em;
    box-sizing: border-box;

    .switcher {
      margin-top: 1em;
    }

    h2 {
      margin-bottom: 0em;
    }

    .filter-option {
      margin: 0.5em 0;
      text-align: center;

      &.teams__hierarchy-tree {
        text-align: left;
        padding: 0;

        .teams__hierarchy-tree__options {
          padding: 0.5em;
        }
      }
    }
  }

  .users-content {
    width: calc(76% - .7rem);
    margin: .7rem 0;
    box-sizing: border-box;
    padding-left: 0.7em;
    position: relative;
    display: inline-flex;
    flex-flow: column;
    height: calc(100% - 1.4rem);

    &-header-options {
      flex: 0 0 auto;

      &__select {
        display: flex;
        justify-content: space-between;

        .option-link {
          margin: 0.5em 1em;
        }
      }
      .add-button {
        margin-bottom: 10px;
        display: inline-flex;
        vertical-align: top;
        padding: 2px;

        &:hover {
          background-color: #dce9f8;
          box-shadow: 0px 0px 4px #dce9f8;
        }
        span {
          flex: 1;
        }
      }
    }
    &-scroller {
      flex: 1;
      overflow: auto;

      .user-item {
        white-space: nowrap;
        margin: 0px 0.3em;
        // WARNING: Changing this value should require a change in itemsHeight (computed)
        padding: 0.25em 0;
      }
      .small-card-item {
        // WARNING: Changing this value should require a change in itemsHeight (computed)
        padding: 0.7em;
        height: 1.5em;
        flex: 1;
        min-width: 0px;

        > * {
          flex: 0 0 auto;

          &.name {
            flex: 1;
            text-overflow: ellipsis;
            overflow: hidden;
            white-space: nowrap;
          }
        }
        &__lock {
          width: 1.4em;
          height: 1.4em;
          margin-right: 0.5em;
        }
      }
      .small-card-item, .user-item-actions {
        white-space: normal;
        margin-bottom: 0px;
      }
      .user-item-actions {
        flex: 0 0 auto;
      }
      .user-item-actions .icon {
        width: 2em;
        height: auto;
        margin-left: 0.3em;
        cursor: pointer;
        box-sizing: border-box;
        padding: 0.35em;

        &:hover {
          background-color: $color-hoverbtn-light-blue;
        }
        &.delete:hover {
          background-color: $color-hoverbtn-red;
        }
      }
      .name, .team {
        line-height: 1.5em;
      }
      .team {
        margin-left: 0.5em;
      }
      .scheme-item-actions {
        white-space: normal;
      }
    }
  }
  .dot {
    width: 6px;
    height: 6px;
    border-radius: 3px;
    margin-right: 8px;
  }
  .config-settings-wrapper {
    position: absolute;
    top: 0px;
    left: 0px;
    z-index: 10006; /* above slider dots */
    background: #ffffff;
    padding: 25px;
    box-sizing:border-box;
  }
  .config-settings {
    overflow: auto;
  }
  .erase-warning {
    background-color: #e39129;
    border-radius: 50%;
    height: 30px;
    width: 30px;
    margin-left: 0.3em;

    .icon {
      color: white;
      height: 18px;
      width: 18px;
    }
  }
  .left-drawer-panel {

    .add-button {
      padding: 0.3em 0.5em;
      margin: 0.2em 0;

      span {
        flex: 1;
      }
    }

    .erase-data-actions {
      margin-top: 30px;
    }

    .sep {
      width: 80%;
      margin: 1.3em 10%;
    }

    h1.basic-blue-title {
      margin-bottom: 1em;
    }
  }
}
</style>
